require('./react-components/src/PartnerRoot');
